import i18n from "../index";

enum DateFormat {
  NUMERIC = 0,
  SHORT = 1,
}

export function formatDate(inputDate: string | Date, formatType: DateFormat = DateFormat.NUMERIC): string {
  const date = new Date(inputDate);

  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  switch (formatType) {
    case DateFormat.NUMERIC:
      return `${(date.getMonth() + 1).toString().padStart(2, "0")}.${date.getDate().toString().padStart(2, "0")}.${date.getFullYear()} ${date.getHours().toString().padStart(2, "0")}:${date
        .getMinutes()
        .toString()
        .padStart(2, "0")}`;
    case DateFormat.SHORT: {
      const options: Intl.DateTimeFormatOptions = { year: "numeric", month: "short", day: "2-digit" };

      // Return the Intl output as-is. The previous 3-token destructure-and-rejoin was an
      // identity for en/tr/es/it/fr but silently dropped the year for pt, whose locale
      // string has 5 tokens ("03 de jul. de 2026" became "03 de jul.").
      return date.toLocaleDateString(i18n.language || "en", options);
    }
    default:
      return "Invalid Format Type";
  }
}

export { DateFormat };
